/**
* In View Hospital function is used to retrieve the Hospital details, physician info and patient info details and 
* its functions declare this file
**/
import { useParams,Link } from 'react-router-dom';
import { useState,useEffect} from 'react';
import ApiService from '../../../services/ApiService';
import { goBack ,convertTimeFormat,convertS3privateToPublic } from '../../../services/UtilsService';
import { useTranslation } from 'react-i18next';

function ViewHospital(){
	 //Intial variable declaration
	 let { id } = useParams();
     const [data,setData]=useState({});
	 const { t } = useTranslation();
	 
	//components initialize function and api handling
	useEffect(()=>{
	   (async()=>{
		 if(id){
		     var response=await ApiService.getOrganization(id);
			 if(response.status===200)
			 setData(response.data);	
		 }
	   })();
   },[id]);
   
	return(
	<main id="main" className="main">
	
	{/*Page Title Section*/}
	<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('profile.viewHospitalInfo')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item"><Link to='/admin/hospital'>{t('sidebar.hospital')}</Link></li>
				  <li className="breadcrumb-item active">{t('profile.viewHospitalInfo')}</li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*End Page Title Section*/}
	
	{/*Page Content Section*/}
	<section>
	<div className="row">
		<div className="col-xxl-4">
			{/*ProfileImg*/}
			<div className="card profile-img">
				<div className="card-body">
					<div className="top-bar">
						{(data && data?.hospitalInfo && data?.hospitalInfo?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/user-avatar.png" alt="IMG" />}
						{(data && data?.hospitalInfo && data?.hospitalInfo?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.hospitalInfo?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
						<h1 className="text-capitalize">{data.hospitalInfo?.name?data.hospitalInfo.name:'--'}</h1>
						<h6 className="text-tmBlue">{data.hospitalInfo?.website?data.hospitalInfo.website:'--'}</h6>
					</div>
					<div className="center-bar clearfix">
						<div className="d-flex align-items-center mb-4">
							<div className="info-icon">
								<i className="iconly-Bold-Send"></i>
							</div>
							<div className="ms-2">
								<p className="mb-0 text-tmBlue">{t('profile.email')}</p>
								<span className="h6 text-dark" style={{ wordBreak : "break-word"}}>{data.hospitalInfo?.email?data.hospitalInfo.email:'--'}</span>
							</div>
						</div>
						<div className="d-flex align-items-center mb-4">
							<div className="info-icon">
								<i className="iconly-Bold-Calling"></i>
							</div>
							<div className="ms-2">
								<p className="mb-0 text-tmBlue">{t('profile.phone')}</p>
								<span className="h6 text-dark">{data.hospitalInfo?.mobileNumber?data.hospitalInfo.countryCode+' '+data.hospitalInfo.mobileNumber:'--'}</span>
							</div>
						</div>
					</div>
					<div className="d-grid mt-4">
                        <Link to={'/admin/edit-hospital/'+id} className="btn btn-block btn-outline-tmBlue">
							<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
						</Link>
					</div>
				</div>
			</div>
		</div>
		
		<div className="col-xxl-8">
			<div className="card profile-info">
				<div className="card-body pt-4">
				    {/*Hospital Info*/}
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className="secTitle">
								<h1>{t('profile.hospitalInfo')}</h1>
							</div>
							<div className="secContent">
								<h6>{t('profile.location')}</h6>
								<p className="text-capitalize">
								{data.hospitalInfo && data.hospitalInfo.address_one
									? data.hospitalInfo.address_one + ', '
									: ''}
								  {data.hospitalInfo && data.hospitalInfo.address_two
									? data.hospitalInfo.address_two + ', '
									: ''}
								  {data.hospitalInfo && data.hospitalInfo.city}, {data.hospitalInfo && data.hospitalInfo.state}, {data.hospitalInfo && data.hospitalInfo.zipcode}</p>
							</div>
						</div>
					</div>
					
				    {/*Admin Info*/}
					<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>{t('profile.adminInfo')}</h1>
								</div>
								<div className="secContent">
									<div className="row">
										<div className="col-lg-4 px-3">
											<h6>{t('profile.adminName')}</h6>
											<p>{data.adminInfo?.admin_name?data.adminInfo?.admin_name:'--'}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.role')}</h6>
											<p>{t('profile.hospitalAdminRole')}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.phoneNumber')}</h6>
											<p>{data.adminInfo?.mobileNumber?data.adminInfo?.mobileNumber:'--'}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.emailAddress')}</h6>
											<p>{data.adminInfo?.email?data.adminInfo?.email:'--'}</p>
										</div>
										{/* <div className="col-lg-4 px-3">
											<h6>{t('profile.gender}</h6>
											<p>{data.adminInfo?.admin_gender === 0 ? 'Male' : data.adminInfo?.admin_gender === 1 ? 'Female' : '--'}</p>
										</div> */}
										<div className="col-lg-6 px-3">
											<h6>{t('profile.webURL')}</h6>
											<p>{data.hospitalInfo?.website?data.hospitalInfo?.website:'--'}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					
					{/*Physician Info*/}
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className="secTitle">
								<h1>{t('profile.physicianInfo')}</h1>
							</div>
							<div className="secContent">
								<div className="table-responsive">	
									<table className="table table-borderless theme-table">
										<thead>
										  <tr>
											<th scope="col">{t('sidebar.physician')}</th>
											<th scope="col">{t('profile.visitingDays')}</th>
											<th scope="col">{t('profile.visitingHours')}</th>
											<th scope="col">{t('profile.consultingDuration')}</th>
										  </tr>
										</thead>
										<tbody>
										{ data && data.physicianInfo && data.physicianInfo.map((item,i)=>(
											<tr className="text-capitalize" key={i}>
												<td  className="prty-td">
													<Link to={'/admin/physician/'+item.physician}>
														<h5 className="table-title">{item.name?item.name:'--'}</h5>
													</Link>
												</td>					
												<td>{item?.days && item?.days.length > 0 ? (
												 item?.days
													.map(day =>[day.trim()] || '--') 
													.reduce((acc, curr, index) => (
													<>
														{acc}
														{index > 0 && ', '}
														{curr}
													</>
													), '')) : (
														'--' // Change: Added fallback for no days
													)}
												</td>				
												<td>
													{item.startTime && item.endTime ? `${convertTimeFormat(item.startTime)} to ${convertTimeFormat(item.endTime)}` : '--'}
												</td>	
												<td>{item.consultingDuration!==null ? item.consultingDuration + ' Mins' : '--'}</td>			
										</tr>))}
										
										</tbody>
									</table>
									{data && data.physicianInfo && data.physicianInfo.length ===0 && <span className="text-center d-block">{t('common.noRecord')}</span>}
								</div>
							</div>
						</div>
					</div>
					
					{/*Patient Info*/}
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className="secTitle">
								<h1>{t('profile.PatientInfo')}</h1>
							</div>
							<div className="secContent">
								<div className="table-responsive">	
									<table className="table table-borderless theme-table">
										<thead>
										  <tr>
											<th scope="col">{t('profile.patient')}</th>
											<th scope="col">{t('profile.physicianName')}</th>
										  </tr>
										</thead>
										<tbody>
											{ data && data.parentInfo&& data.parentInfo.filter(item => item.parent !== null && item.physician !== null).map((item, i) => (<tr key={i} className="text-capitalize">
												<td  className="prty-td">
													<Link to={'/admin/parent/'+item.parent}>
														<h5 className="table-title">{item.parentname}</h5>
													</Link>
												</td>
												<td  className="prty-td">
													<Link to={'/admin/physician/'+item.physician}>
														<h5 className="table-title">{item.physicianname}</h5>
													</Link>
												</td>
											</tr>))}
											
										</tbody>
									</table>
									{data && data.parentInfo && data.parentInfo.length ===0 && <span className="text-center d-block">{t('common.noRecord')}</span>}
								  </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/* End Page Content Section */}
	
</main>
	
	);
	
}

export default ViewHospital;